import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_care/care-pass")({
  beforeLoad: ({ context }) => guardRoute(context.me, "care-pass"),
  component: Outlet,
});
